import {app} from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.password-authentication-policy.manage', {
        url: '/:policyId/manage',
        views: {'@company.policies': 'passwordAuthenticationPolicyAssignApplication'},
        resolve: {
            policy,
            policyId,
        },
    });
}

/** @ngInject */
function policy(policyId, companyPasswordPolicies) {
    return companyPasswordPolicies.find(p => p.passwordPolicyId === policyId);
}

/** @ngInject */
function policyId($stateParams) {
    return $stateParams.policyId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/assign-application/assign-application.state.js